import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_UNCLAIMED_CARGO_ITEMS,
  FLAG_GETTING_UNCLAIMED_CARGO_ITEMS,
  FLAG_LEGAL_ABANDONMENT_ACTIVITY,
  GET_UNCLAIMED_CARGO_ITEMS,
} from '../../../actions/types/cargo';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_UNCLAIMED_CARGO_ITEMS:
      return state.setIn(['all', 'loading'], payload);
    case GET_UNCLAIMED_CARGO_ITEMS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case FLAG_LEGAL_ABANDONMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case CLEAR_UNCLAIMED_CARGO_ITEMS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
